import { FC } from 'react'
import { FormikProps } from 'formik'
import { SharedModalInputs } from '../SharedModal/styled'
import { ShortFormControl } from '../../styled/common'
import { FormGroup, Select } from '@agro-club/agroclub-shared'
import { QuantityInput } from '../QuantityInput/QuantityInput'
import { VehicleTypeCheckboxGroup } from '../CheckboxGroup/VehicleTypeCheckboxGroup'
import { ScheduleControls } from '../ScheduleControls/ScheduleControls'
import { YesNoUnknownRadio } from './YesNoUnknownRadio'
import { useTranslation } from 'react-i18next'
import { BoolRadio } from '../BoolRadio/BoolRadio'
import { OverloadRadio } from 'views/components/OverloadRadio/OverloadRadio'
import { BuyerWarehouseDTO, UnloadingType, WarehouseDTO } from 'modules/domain/types'
import { WeatherControl } from './WeatherControl'

type Props = {
  formik: FormikProps<BuyerWarehouseDTO>
  boolDeliveryRadio?: boolean //Probably a temporary solution, since the new logistics have switched to BoolRadio
}

export const BuyerWarehouseFields: FC<Props> = ({ formik, boolDeliveryRadio }) => {
  const { t } = useTranslation('address')

  return (
    <SharedModalInputs>
      <VehicleTypeCheckboxGroup formik={formik} />
      <BoolRadio fieldName="is_dump_truck" formik={formik} label={t('fields.is_dump_truck')} />
      <ShortFormControl>
        <FormGroup label={t('fields.unloading_type')} error={formik.errors.unloading_type}>
          <Select
            onChange={(val) => formik.setFieldValue('unloading_type', val)}
            options={Object.keys(UnloadingType).map((val) => ({
              value: val,
              label: t(`vehicles:unloadingType.${val}`),
            }))}
            value={formik.values.unloading_type}
            showSearch={false}
            fullWidth
            allowClear={false}
          />
        </FormGroup>
        <QuantityInput formik={formik} fieldName="volume_per_day" label={t('fields.volume_per_day.customer')} />
        <BoolRadio label={t(`fields.timeslot_required`)} fieldName="timeslot_required" formik={formik} />
      </ShortFormControl>
      <WeatherControl formik={formik as unknown as FormikProps<WarehouseDTO>} />
      <OverloadRadio formik={formik} />
      <FormGroup label={t('fields.schedule.customer')}>
        <ScheduleControls formik={formik as unknown as FormikProps<WarehouseDTO>} />
      </FormGroup>
      {['works_on_weekend', 'car_delivery', 'railway_delivery'].map((fieldName) =>
        boolDeliveryRadio ? (
          //Probably a temporary solution, since the new logistics have switched to BoolRadio
          <BoolRadio
            key={fieldName}
            label={t(`logisticsKR:list:createForm:labels:${fieldName}`)}
            fieldName={fieldName}
            formik={formik}
          />
        ) : (
          <FormGroup key={fieldName} label={t(`logisticsKR:list:createForm:labels:${fieldName}`)}>
            <YesNoUnknownRadio
              onChange={(value) => formik.setFieldValue(fieldName, value)}
              value={formik.values[fieldName]}
            />
          </FormGroup>
        ),
      )}
    </SharedModalInputs>
  )
}
